import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useTranslation } from "react-i18next";
import { useGetAttachmentUrlMutation } from "@/features/Global/api";

const AttachmentPreview = ({ attachment }) => {
  const { t } = useTranslation(["bugherd"]);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  // For direct display of base64 images - no need for server URL fetching
  const isBase64 = attachment?.url?.startsWith("data:");

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const handleImageError = () => {
    setIsImageLoading(false);
    setImageError(true);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        bgcolor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {isBase64 ? (
        <>
          {/* For base64 images, display directly */}
          <img
            src={attachment.url}
            alt={attachment.fileName}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: imageError ? "none" : "block",
            }}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />

          {isImageLoading && (
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <CircularProgress size={24} />
            </Box>
          )}

          {imageError && (
            <Box sx={{ textAlign: "center", p: 2 }}>
              <AttachFileIcon sx={{ fontSize: 36, color: "#9e9e9e" }} />
              <Typography
                variant="caption"
                display="block"
                color="text.secondary"
                mt={0.5}
              >
                {t("Failed to load image")}
              </Typography>
            </Box>
          )}
        </>
      ) : (
        <Box sx={{ textAlign: "center", p: 2 }}>
          <AttachFileIcon sx={{ fontSize: 36, color: "#9e9e9e" }} />
          <Typography
            variant="caption"
            display="block"
            color="text.secondary"
            mt={0.5}
          >
            {t("Preview not available")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default AttachmentPreview;
